import React, { useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Form from 'react-bootstrap/Form';

const Practice = (props: any) => {

  const cardioCalifornia = ["Alex", "Irfan", "Ram", "Smith", "TestProvider"];
  const healthFlorida = ["Alex", "Irfan", "Ram"];
  const healthNewYork = ["Smith", "TestProvider"];
  const TestPractice = ["Irfan", "Ram", "Smith"];

  return (
    <div className="d-flex align-items-end flex-column h-100">
      <div>
        <div className='mb-4 fs-12 text-light'>Spaces to manage care user, care program, workflow based on selected provider.</div>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>Arjuna Cardio - California</Accordion.Header>
            <Accordion.Body>
              {cardioCalifornia.map((type, index) => (
                <div key={`checkbox-${type}${index}`}>
                  {index !=0 && <hr className='my-1'/>}
                  <Form.Check
                    type={'checkbox'}
                    id={`checkbox-${type}${index}`}
                    label={type}
                  />
                </div>
              ))}
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>Arjuna Health - Florida</Accordion.Header>
            <Accordion.Body>
              {healthFlorida.map((type, index) => (
                  <div key={`checkbox-${type}${index}`}>
                    {index !=0 && <hr className='my-1'/>}
                    <Form.Check
                      type={'checkbox'}
                      id={`checkbox-${type}${index}`}
                      label={type}
                    />
                  </div>
                ))}
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>Arjuna Health - NewYork</Accordion.Header>
            <Accordion.Body>
              {healthNewYork.map((type, index) => (
                  <div key={`checkbox-${type}${index}`}>
                    {index !=0 && <hr className='my-1'/>}
                    <Form.Check
                      type={'checkbox'}
                      id={`checkbox-${type}${index}`}
                      label={type}
                    />
                  </div>
                ))}
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>Test Practice 2</Accordion.Header>
            <Accordion.Body>
              {TestPractice.map((type, index) => (
                  <div key={`checkbox-${type}${index}`}>
                    {index !=0 && <hr className='my-1'/>}
                    <Form.Check
                      type={'checkbox'}
                      id={`checkbox-${type}${index}`}
                      label={type}
                    />
                  </div>
                ))}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <div className="offcanvas-footer text-end w-100 border-top d-flex justify-content-between border-top">
        <button className="btn btn-sm btn-danger text-white text-nowrap rounded-2 me-2 px-4 fs-13" type="button">Discard</button>
        <button className="btn btn-sm btn-secondary text-white text-nowrap rounded-2 px-4 fs-13" type="button">Apply</button>
      </div>
    </div>
  );
}
export default Practice;